import React from 'react';
import AlertTemplate from './templates/alert-template';

class Alert {
  constructor() {
    this.id = 0;
    this.alerts = new Map();
    this.alertTemplate = AlertTemplate;
    this.open = {};
    this.confirm = this.confirm.bind(this);
    this.notify = this.notify.bind(this);
  }

  setProvider(provider) {
    this.provider = provider;
  }

  getId() {
    const { id } = this;
    this.id += 1;
    return id;
  }

  updateAlerts() {
    const alerts = [];
    this.alerts.forEach((value) => {
      alerts.push(value.alert(value.open));
    });
    this.provider(alerts);
  }

  showAlert(id, alert) {
    this.alerts.set(id, { alert, open: true });
    this.updateAlerts();
  }

  removeAlert(id) {
    const alert = this.alerts.get(id) || {};
    alert.open = false;
    this.alerts.set(id, alert);
    setTimeout(() => {
      this.alerts.delete(id);
    }, 1000);
    this.updateAlerts();
  }

  notify(title, text, actionText) {
    if (this.provider == null) {
      return Promise.reject(new Error('No Alert provider assigned'));
    }
    return new Promise((resolve) => {
      const id = this.getId();
      const Template = this.alertTemplate;
      this.showAlert(id, (open) => (
        <Template
          key={id}
          open={open}
          title={title}
          content={text}
          acceptText={actionText}
          onAccept={() => {
            this.removeAlert(id);
            resolve();
          }}
          onClose={() => {
            this.removeAlert(id);
            resolve();
          }}
        />
      ));
    });
  }

  show(factory) {
    const id = this.getId();
    this.showAlert(
      id,
      factory(id, () => {
        this.removeAlert(id);
      })
    );
  }

  confirm(title, text, acceptText, rejectText, cancelable) {
    if (this.provider == null) {
      return Promise.reject(new Error('No Alert provider assigned'));
    }
    return new Promise((resolve) => {
      const id = this.getId();
      const Template = this.alertTemplate;
      this.showAlert(id, (open) => (
        <Template
          key={id}
          open={open}
          title={title}
          content={text}
          acceptText={acceptText}
          onAccept={() => {
            this.removeAlert(id);
            resolve({ action: 'accept' });
          }}
          rejectText={rejectText}
          onReject={() => {
            this.removeAlert(id);
            resolve({ action: 'reject' });
          }}
          onClose={
            cancelable &&
            (() => {
              this.removeAlert(id);
              resolve({ action: 'cancel' });
            })
          }
        />
      ));
    });
  }
}
export default new Alert();
